import React from 'react';
import styled from 'styled-components';

import { LinkConfiguration } from '../../../clients/sites/model';
import { AnalyticsConsumerProps, withAnalytics } from '../../../hoc/withAnalytics';
import { Product } from '../../../store/productStore';
import InvisibleCardList from '../InvisibleCardList';
import { default as LinkCard } from '../LinkCard';
import ProductCard from '../ProductCard';
import { FlexGrow, RowHeader, RowHeaderWrapper } from '../styled';

import { ProductContainer, RowHeaderAction, RowSubHeader } from './styled';

export const Header = styled.div`
  font-size: 16px;
  font-weight: 600;
  height: 22px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface Props {
  action?: JSX.Element;
  fixedCard?: JSX.Element;
  fullScreen?: boolean;
  header?: string | JSX.Element;
  hideSiteName?: boolean;
  joinable?: boolean;
  links?: LinkConfiguration[];
  maxCardsPerRow: number;
  products?: Product[];
  singleRow?: boolean;
  subHeader?: string | JSX.Element;
}

class CardRow extends React.Component<Props & AnalyticsConsumerProps> {
  getVisibleCards() {
    const {
      products = [],
      fullScreen,
      hideSiteName,
      joinable,
      links = [],
      singleRow,
      maxCardsPerRow,
      fixedCard,
    } = this.props;

    const productCards = products.map((product: Product) => {
      return (
        <ProductCard
          data-test-id="product-card"
          key={product.cloudId + product.productName}
          {...product}
          fullScreen={fullScreen}
          hideSiteName={hideSiteName}
          joinable={joinable}
        />
      );
    });
    const linkCards = links.map((link: LinkConfiguration) => (
      <LinkCard data-test-id="link-card" key={link.labelAnalyticKey} {...link} fullScreen={fullScreen} />
    ));

    let visibleCards = [...productCards, ...linkCards];

    const shouldShowFixedCard =
      fixedCard && !visibleCards.some((card, idx) => idx < maxCardsPerRow && card.key === fixedCard.key);

    if (singleRow) {
      visibleCards = visibleCards.slice(0, shouldShowFixedCard ? maxCardsPerRow - 1 : maxCardsPerRow);
    }

    if (shouldShowFixedCard) {
      visibleCards.push(fixedCard);
    }

    return visibleCards;
  }

  render() {
    const { action, header, subHeader, maxCardsPerRow } = this.props;

    const visibleCards = this.getVisibleCards();

    return (
      <React.Fragment>
        {header && (
          <RowHeaderWrapper>
            <RowHeader>{header}</RowHeader>
            {subHeader && <RowSubHeader>{subHeader}</RowSubHeader>}
            <FlexGrow />
            <RowHeaderAction>{action}</RowHeaderAction>
          </RowHeaderWrapper>
        )}
        <ProductContainer data-testid="product-container">
          {visibleCards}
          <InvisibleCardList productsCount={visibleCards.length} maxCardsPerRow={maxCardsPerRow} />
        </ProductContainer>
      </React.Fragment>
    );
  }
}

export default withAnalytics(CardRow);
